export default "__VITE_ASSET__BXGypxb8__"